import { Phone, CheckCircle2, CalendarClock, PhoneMissed, PhoneCall } from "lucide-react";

const fmtWhen = (iso) => {
  const d = iso && new Date(iso);
  return d && !isNaN(d) ? d.toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit", timeZoneName: "short" }) : null;
};

function phoneState(c) {
  const num = <span className="font-semibold text-slate-900">{c.phone || "the number you provided"}</span>;
  const when = fmtWhen(c.reschedule_time);
  switch (c.phone_status) {
    case "completed":
      return { key: "completed", tone: "emerald", Icon: CheckCircle2, title: "Phone screen completed", body: "Thanks, you've finished the phone round. Continue with the steps below." };
    case "scheduled":
    case "rescheduled":
      if (when) return { key: "scheduled", tone: "indigo", Icon: CalendarClock, title: `Phone screen booked for ${when}`, body: <>Our AI recruiter will call you on {num} at that time. You can complete the steps below before or after the call.</> };
      break;
    case "dialing":
      return { key: "dialing", tone: "indigo", Icon: PhoneCall, title: "Phone screen in progress", body: <>Our AI recruiter is calling you on {num}. You can continue the steps below once the call is done.</> };
    case "no_answer":
    case "missed":
      return { key: "missed", tone: "amber", Icon: PhoneMissed, title: "We couldn't reach you by phone", body: <>We tried calling {num}. The hiring team will call again or get in touch. You can still complete the steps below.</> };
    case "incomplete":
      return { key: "incomplete", tone: "amber", Icon: PhoneMissed, title: "Phone screen not finished", body: <>The call ended before the screening was complete. The hiring team will call you again on {num}. You can still complete the steps below.</> };
    case "declined":
      return { key: "declined", tone: "slate", Icon: Phone, title: "Phone screen not completed", body: "You can still complete the steps below." };
    default:
  }
  return { key: "pending", tone: "indigo", Icon: Phone, title: "A short phone screen is part of this process", body: <>Our AI recruiter will call you on {num} for a brief telephonic round. The steps below run here in the browser.</> };
}

const TONES = {
  indigo: ["border-indigo-100 bg-indigo-50", "text-indigo-600 border-indigo-200"],
  emerald: ["border-emerald-100 bg-emerald-50", "text-emerald-600 border-emerald-200"],
  amber: ["border-amber-100 bg-amber-50", "text-amber-600 border-amber-200"],
  slate: ["border-slate-200 bg-slate-50", "text-slate-500 border-slate-200"],
};

export default function PhoneStatusNotice({ candidate }) {
  const s = phoneState(candidate);
  const [box, icon] = TONES[s.tone];
  return (
    <div className={`mb-4 p-3 rounded-lg border flex items-start gap-3 ${box}`} data-testid="telephonic-notice" data-state={s.key}>
      <div className={`w-9 h-9 rounded-lg bg-white border grid place-items-center flex-shrink-0 ${icon}`}><s.Icon className="w-4 h-4" /></div>
      <div>
        <div className="font-semibold text-slate-900 text-sm" data-testid="telephonic-notice-title">{s.title}</div>
        <div className="text-sm text-slate-600 leading-relaxed mt-0.5">{s.body}</div>
      </div>
    </div>
  );
}
